<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="subheadline">Importar Condiciones</span>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">Volver</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="crearCondiciones" v-if="canCrear">Crear</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="openFileDirectory" color="primary" class="action-button-xls">
              <AttachFile ref="fileInput" @upload="uploadExcel" singleFile v-show="files.length"></AttachFile>
              <span>Cargar Condiciones XLS</span>
              <v-icon right small>table_view</v-icon>
            </v-btn>
          </v-card-actions>
          <div v-if="loading" class="spacing-top">
            <v-flex offset-xs5 pa-5>
              <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </div>
          <div v-else>
            <div v-if="displayTables">
              <div v-if="isValidFile">
                <div class="validUpload">
                  Se procedera a crear {{ validCount }} condiciones.
                </div>
                <condiciones-diffs :condiciones="validRows"></condiciones-diffs>
              </div>
              <div v-else>
                <div class="invalidUpload">
                  <div v-if="hasBaseErrors">
                    <span v-for="(error, index) in baseErrors" :key="index">
                      {{ error.errores }}
                    </span>
                  </div>
                  <span v-else>
                    Se encontraron los siguientes errores:
                  </span>
                </div>
                <condiciones-errors v-if="!hasBaseErrors" :condiciones="invalidRows"></condiciones-errors>
              </div>
            </div>
            <div v-else-if="showPostCreationText" class="validUpload">
              {{ validCount }} condiciones condiciones fueron creadas.
            </div>
            <ConfirmationDialog :function-yes="bindingFunction" ref="confirmLeave" title="Abandonar formulario"
                      text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
          </div>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>

</template>

<script>

import { createEntityMixin } from '../../../mixins/createEntityMixin'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import CondicionesDiffs from './CondicionesDiffs'
import CondicionesErrors from './CondicionesErrors'
import AttachFile from '../../../common/ui/AttachFile'

export default {
  mixins: [createEntityMixin],

  components: {
    ConfirmationDialog,
    AttachFile,
    CondicionesErrors,
    CondicionesDiffs
  },

  data () {
    return {
      dialog: false,
      loading: false,
      cacheName: null,
      totalCount: null,
      invalidCount: null,
      validCount: null,
      baseErrors: null,
      isValidFile: false,
      validRows: [],
      invalidRows: [],
      displayTables: false,
      showPostCreationText: false
    }
  },

  methods: {
    uploadExcel (signal) {
      this.uploadFiles(signal)
      let payload = new FormData()
      payload.append('condiciones', this.files[0], this.files[0].name)

      this.axios
        .put(`condiciones/xls_import`, payload)
        .then(response => {
          this.validRows = response.data.validRows
          this.invalidRows = response.data.invalidRows
          this.validCount = response.data.validRowsCount
          this.invalidCount = response.data.invalidRowsCount
          this.totalCount = response.data.totalRows
          this.cacheName = response.data.cacheName
          this.baseErrors = response.data.baseErrors
          this.isValidFile = response.data.isValidFile
          this.$refs.fileInput.cleanContent()
          this.showPostCreationText = false
          this.displayTables = true
        })
        .catch(error => {
          this.$refs.fileInput.cleanContent()
          this.cacheName = null
          this.showPostCreationText = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    crearCondiciones () {
      let payload = {
        cacheName: this.cacheName
      }
      this.axios
        .post(`condiciones/xls_import`, payload)
        .then(response => {
          this.displayTables = false
          this.showPostCreationText = true
          this.cacheName = null
        })
        .catch(error => {
          this.cacheName = null
          this.showPostCreationText = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    resetComponent () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    showDialog () {
      this.resetComponent()
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    }
  },

  computed: {
    canCrear () {
      return this.cacheName != null
    },
    hasBaseErrors () {
      return this.baseErrors.length > 0
    }
  }
}
</script>
<style scoped>
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
.invalidUpload {
  padding: 2em;
  background-color: rgb(202,120,120);
  border-radius: 0.5em;
  color: rgb(250,250,250);
}
.validUpload {
  padding: 2em;
  border-radius: 0.5em;
  color: rgb(250,250,250);
  background-color: rgb(120,202,120)
}
</style>
